import __request__ from 'routing/request';
interface ResponseSchemaEntry {
    readonly field: string;
    readonly function: string;
    readonly name: string;
    readonly column_type: 'grouping' | 'metric' | 'field';
    readonly type: 'string' | 'numeric' | 'date' | 'boolean' | 'binary' | 'ip' | 'geo' | 'stream' | 'input' | 'node' | 'unknown';
}
interface TimeRange {
    readonly type: string;
}
interface TabularResponse {
    readonly schema: ResponseSchemaEntry[];
    readonly metadata: Metadata;
    readonly datarows: unknown[][];
}
interface AbsoluteRange {
    readonly from: string;
    readonly to: string;
    readonly type: string;
}
interface MetricConfiguration {
}
interface Metadata {
    readonly effective_timerange: AbsoluteRange;
}
interface MessagesRequestSpec {
    readonly stream_categories: string[];
    readonly timerange: TimeRange;
    readonly size: number;
    readonly query: string;
    readonly streams: string[];
    readonly from: number;
    readonly sort: string;
    readonly fields: string[];
    readonly sort_order: 'Ascending' | 'Descending';
}
interface Grouping {
    readonly field: string;
    readonly limit: number;
}
interface Metric {
    readonly field: string;
    readonly configuration: MetricConfiguration;
    readonly function: string;
    readonly sort: 'Ascending' | 'Descending';
}
type stringArray = string[];
interface AggregationRequestSpec {
    readonly stream_categories: string[];
    readonly timerange: TimeRange;
    readonly query: string;
    readonly streams: string[];
    readonly group_by: Grouping[];
    readonly metrics: Metric[];
}
/**
 * Execute aggregation specified by `searchRequestSpec`
 */
export function aggregateSearchRequestSpec(searchRequestSpec?: AggregationRequestSpec): Promise<TabularResponse> {
    return __request__('POST', '/plugins/org.graylog.plugins.views/search/aggregate', searchRequestSpec, {}, {
        'Accept': []
    });
}
/**
 * Execute aggregation specified by query parameters
 * @param query Query (Lucene syntax)
 * @param streams Comma separated list of streams to search in (can be empty)
 * @param stream_categories Comma separated list of streams categories to search in (can be empty)
 * @param timerange Timeframe to search in. See method description.
 * @param groups Group aggregation by fields/limits.
 * @param metrics Metrics to be used.
 */
export function aggregateForQueryParameters(query: string, streams: stringArray, stream_categories: stringArray, timerange: string, groups: stringArray, metrics: stringArray): Promise<TabularResponse> {
    return __request__('GET', '/plugins/org.graylog.plugins.views/search/aggregate', null, { 'query': query, 'streams': streams, 'stream_categories': stream_categories, 'timerange': timerange, 'groups': groups, 'metrics': metrics }, {
        'Accept': []
    });
}
/**
 * Execute query specified by `queryRequestSpec`
 */
export function messagesByQueryRequestSpec(queryRequestSpec?: MessagesRequestSpec): Promise<TabularResponse> {
    return __request__('POST', '/plugins/org.graylog.plugins.views/search/messages', queryRequestSpec, {}, {
        'Accept': []
    });
}
/**
 * Execute query specified by query parameters
 * @param query Query (Lucene syntax)
 * @param streams Comma separated list of streams to search in
 * @param stream_categories Comma separated list of streams categories to search in
 * @param timerange Timeframe to search in. See method description.
 * @param fields Fields from the message to show as columns in result
 * @param sort Field to sort on
 * @param sortOrder Sort order - asc/desc
 * @param from For paging results. Starting from result
 * @param size Page size
 */
export function messagesByQueryParameters(query: string, timerange: string, streams?: stringArray, stream_categories?: stringArray, fields?: stringArray, sort?: string, sortOrder?: 'Ascending' | 'Descending', from?: number, size?: number): Promise<TabularResponse> {
    return __request__('GET', '/plugins/org.graylog.plugins.views/search/messages', streams, { 'query': query, 'stream_categories': stream_categories, 'timerange': timerange, 'fields': fields, 'sort': sort, 'sortOrder': sortOrder, 'from': from, 'size': size }, {
        'Accept': []
    });
}
